import styled, { css } from "styled-components";
import { useSelector } from "react-redux";

import * as Types from "Types";
import * as grid from "grid";

import MoleculeChannel from "Components/Molecules/SectionChannels/Channel";
import MoleculeXSChannel from "Components/Molecules/SectionChannels/XSChannel";
import * as icons from "icons";

const Wrap = styled.div<Types.Default>`
   position: relative;
   display: flex;
   flex-direction: row;
   justify-content: center;
   ${({ css }) => css}
`;

const XSWrap = styled.div<Types.Default>`
   position: relative;
   display: flex;
   flex-direction: column;
   justify-content: center;
   padding: 0 5%;
   ${({ css }) => css}
`;

const RowWrap = styled.div<Types.Default>`
   position: relative;
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   column-gap: 5%;
   ${({ css }) => css}
`;

const Channel = styled(MoleculeChannel)``;
const XSChannel = styled(MoleculeXSChannel)`
   width: 20%;
`;

export default function Channels(props: Types.Default) {
   const windowWidth = useSelector(({ dimensions }: Types.State) => dimensions.width);
   const shows = grid.shows({
      width: windowWidth,
      grids: { xs: false },
   });
   return (
      <Wrap {...props}>
         {shows ? (
            <>
               <Channel href="https://bit.ly/3xYYbs4">
                  <Channel.Icon src={icons.application}></Channel.Icon>
                  <Channel.Text>어플리케이션</Channel.Text>
               </Channel>
               <Channel href="https://www.instagram.com/artmap.official">
                  <Channel.Icon src={icons.instagram}></Channel.Icon>
                  <Channel.Text>인스타그램</Channel.Text>
               </Channel>
               <Channel href="https://www.facebook.com/ArtMapApp">
                  <Channel.Icon src={icons.facebook}></Channel.Icon>
                  <Channel.Text>페이스북</Channel.Text>
               </Channel>
               <Channel href="http://pf.kakao.com/_HPbTd">
                  <Channel.Icon src={icons.kakao}></Channel.Icon>
                  <Channel.Text>카카오 채널 뷰</Channel.Text>
               </Channel>
               <Channel href="http://naver.me/FvWs5j26">
                  <Channel.Icon src={icons.naver}></Channel.Icon>
                  <Channel.Text>네이버 포스트</Channel.Text>
               </Channel>
               <Channel href="https://blog.naver.com/artmap-korea">
                  <Channel.Icon src={icons.naverblog}></Channel.Icon>
                  <Channel.Text>네이버 블로그</Channel.Text>
               </Channel>
               <Channel href="https://brunch.co.kr/@artmap-magazine#articles">
                  <Channel.Icon src={icons.brunch}></Channel.Icon>
                  <Channel.Text>브런치</Channel.Text>
               </Channel>
               <Channel href="https://www.youtube.com/channel/UCC9z8mSGqtT7CWI56l_N11A/featured">
                  <Channel.Icon src={icons.youtube}></Channel.Icon>
                  <Channel.Text>유튜브</Channel.Text>
               </Channel>
            </>
         ) : (
            <XSWrap>
               <RowWrap>
                  <XSChannel href="https://bit.ly/3xYYbs4">
                     <XSChannel.Icon src={icons.application}></XSChannel.Icon>
                     <XSChannel.Text>어플리케이션</XSChannel.Text>
                  </XSChannel>
                  <XSChannel href="https://www.instagram.com/artmap.official">
                     <XSChannel.Icon src={icons.instagram}></XSChannel.Icon>
                     <XSChannel.Text>인스타그램</XSChannel.Text>
                  </XSChannel>
                  <XSChannel href="https://www.facebook.com/ArtMapApp">
                     <XSChannel.Icon src={icons.facebook}></XSChannel.Icon>
                     <XSChannel.Text>페이스북</XSChannel.Text>
                  </XSChannel>
                  <XSChannel href="http://pf.kakao.com/_HPbTd">
                     <XSChannel.Icon src={icons.kakao}></XSChannel.Icon>
                     <XSChannel.Text>카카오 채널 뷰</XSChannel.Text>
                  </XSChannel>
               </RowWrap>
               <RowWrap
                  css={css`
                     margin-top: 37px;
                  `}>
                  <XSChannel href="http://naver.me/FvWs5j26">
                     <XSChannel.Icon src={icons.naver}></XSChannel.Icon>
                     <XSChannel.Text>네이버 포스트</XSChannel.Text>
                  </XSChannel>
                  <XSChannel href="https://blog.naver.com/artmap-korea">
                     <XSChannel.Icon src={icons.naverblog}></XSChannel.Icon>
                     <XSChannel.Text>네이버 블로그</XSChannel.Text>
                  </XSChannel>
                  <XSChannel href="https://brunch.co.kr/@artmap-magazine#articles">
                     <XSChannel.Icon src={icons.brunch}></XSChannel.Icon>
                     <XSChannel.Text>브런치</XSChannel.Text>
                  </XSChannel>
                  <XSChannel href="https://www.youtube.com/channel/UCC9z8mSGqtT7CWI56l_N11A/featured">
                     <XSChannel.Icon src={icons.youtube}></XSChannel.Icon>
                     <XSChannel.Text>유튜브</XSChannel.Text>
                  </XSChannel>
               </RowWrap>
            </XSWrap>
         )}
      </Wrap>
   );
}
